/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Error_ProcessingInputs */

const en_try_magic_error_processing = /** @type {(inputs: Try_Magic_Error_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait while we process your current request`)
};

const es_try_magic_error_processing = /** @type {(inputs: Try_Magic_Error_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor espera mientras procesamos tu solicitud actual`)
};

/**
* | output |
* | --- |
* | "Please wait while we process your current request" |
*
* @param {Try_Magic_Error_ProcessingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_error_processing = /** @type {((inputs?: Try_Magic_Error_ProcessingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Error_ProcessingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_error_processing(inputs)
	return en_try_magic_error_processing(inputs)
});